import { useTranslation } from 'react-i18next'
import Config, { priceForLanguage } from '../../../lib/Config'
import Headline from '../../Elements/Headline'
import Text from '../../Elements/Text'

// Shown for a free budget's premium-only actions (sharing, allowance,
// balance overview) — those stay locked regardless of trial/payment status.
const PremiumFeaturePaywall = () => {
  const { t, i18n } = useTranslation(['budget'])

  return (
    <>
      <Headline>{t('budget:premiumFeaturePaywall.title')}</Headline>
      <Text className='my-6'>
        {t('budget:premiumFeaturePaywall.text', {
          price: priceForLanguage(Config.PRICE_BUDGET, i18n.language),
        })}
      </Text>
    </>
  )
}

export default PremiumFeaturePaywall
